import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { chat as chatApi } from '@/lib/trackizy';

/**
 * Unread chat badge. `enabled` is the org's Chat module (`useFeatures().chat`):
 * without it the server's featureChat guard would 403 every 30 s poll
 * (combined app release spec §2.4), so nothing is fetched and the badge is 0.
 */
export default function useChatUnreadCount(enabled = true) {
  const user = useSelector((state) => state.session.user);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user || !enabled) {
      setCount(0);
      return undefined;
    }

    const fetchCount = async () => {
      try {
        const data = await chatApi.unreadCount();
        setCount(typeof data === 'number' ? data : (data?.count || 0));
      } catch {
        // Silently ignore — badge shows 0
      }
    };

    fetchCount();

    // Refresh every 30s
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, [user, enabled]);

  return count;
}
